import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import $ from 'jquery';

class EditTax extends BasePage {

    loadOnConstructor(){
		this.getTaxInterface = this.getTaxInterface.bind(this);
		this.cancelButton = this.cancelButton.bind(this);
		this.saveButton = this.saveButton.bind(this);
		this.updateTaxCallback = this.updateTaxCallback.bind(this);
		this.newTaxCallback = this.newTaxCallback.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.parseResponse = this.parseResponse.bind(this);
		this.stringBackToStringFront = this.stringBackToStringFront.bind(this);

		const {tax_id} = this.getUrlParams();
		if(tax_id !== undefined){
			this.state = {action: 'modify'};
			this.getTaxInterface(tax_id);
		}else{
			this.state = {action: 'new', isSaving: false};
			this.getTaxInterface();
		}
    }

    getTaxInterface(taxId){
		const api = this.getApi();
		api.getEditTaxInterface(taxId, this.parseResponse);
    }

    parseResponse(response){
		if(response.hasOwnProperty('auth') && response.auth === false){
			this.navigateTo('/login');
			return;
		}

		if(response.status === 'OK'){
			if(this.state.action === 'modify'){
				response.tax.creation_date = this.stringBackToStringFront(response.tax.creation_date);
				response.tax.modification_date = this.stringBackToStringFront(response.tax.modification_date);

				this.setState(prevState => {
					return {
						...prevState,
						tax: response.tax,
						i18n: response.i18n
					}
				});
			}else{
				this.setState(prevState => {
					return {
						...prevState,
						users: response.users,
						i18n: response.i18n
					}
				});
			}
		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}
	}

	stringBackToStringFront(originalStr){
		const objDate = new Date(originalStr);

		return objDate.getUTCFullYear() + "-" +
			("0" + (objDate.getUTCMonth()+1)).slice(-2) + "-" +
			("0" + objDate.getUTCDate()).slice(-2) + " " +
			("0" + objDate.getUTCHours()).slice(-2) + ":" +
			("0" + objDate.getUTCMinutes()).slice(-2) + ":" +
			("0" + objDate.getUTCSeconds()).slice(-2);
	}

	cancelButton(){
		this.goBack();
    }

    saveButton(){

		let failedValidators = {};

		if($('#name').val() === ''){
			failedValidators.name = this.getTrad('fillTaxName');
		}

		if(Object.keys(failedValidators).length !== 0){
			let message = [];
			for (let m in failedValidators){
				message.push(failedValidators[m]);
			}
			this.props.setModalContent({
				title: 'Debe completar los datos obligatorios',
				body: message,
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true }
				]
			});

			$("#exampleModal").modal('toggle');
			return;
		}

		const api = this.getApi();

		this.setState({ isSaving: true })
		if(this.state.action === 'modify'){
				api.updateTax(this.state.tax,this.updateTaxCallback);
		}else{
				api.newTax(this.state.tax,this.newTaxCallback);
		}
    }

    updateTaxCallback(response){
		this.setState({ isSaving: false })
	    if(response.status === 'OK'){
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: ['El impuesto ha sido modificado satisfactoriamente.'],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			    ]
		    });

		    $("#exampleModal").modal('toggle');
	    }else{
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: [this.getTrad(response.message)],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true}
			    ]
		    });

		    $("#exampleModal").modal('toggle');

	    }
    }

    newTaxCallback(response){
		this.setState({ isSaving: false })
		if(response.status !== 'OK'){

			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: [this.getTrad(response.message)],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
				]
			});

			$("#exampleModal").modal('toggle');

		}else{
			this.props.setModalContent({
				title: this.getTrad('messageFromServer'),
				body: ['El impuesto ha sido creado satisfactoriamente.'],
				buttons: [
					{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
				]
			});

			$("#exampleModal").modal('toggle');
		}
    }

    handleChange(event) {

		let taxMod = this.state.tax?this.state.tax:{};
		taxMod[event.target.name] = event.target.value;

		this.setState(prevState => {
			return {
			...prevState,
			tax: taxMod
		}});
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.state.action === 'new'?this.getTrad('taxInsertion'):this.getTrad('taxEdition')}</h3>
                <div className="row mt-4">
			<div className="col-12">
			
			{(this.state.tax || this.state.action === 'new')?
				<form>
				  
				  <div className="form-group">
				    <label htmlFor="name">Nombre</label>
				    <input type="text" className="form-control" id="name" name="name"
				    defaultValue={this.state.tax?this.state.tax.name:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="value">Valor</label>
				    <input type="text" className="form-control" id="value" name="value"
				    defaultValue={this.state.tax?this.state.tax.value:''} onChange={this.handleChange} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="description">{this.getTrad('description')}</label>
				    <textarea type="text" className="form-control" id="description" name="description"
				    onChange={this.handleChange} defaultValue={this.state.tax?this.state.tax.description:''} />
				  </div>
				  <div className="form-group">
				    <label htmlFor="verifactu_exencion_code">Código de exención Verifactu</label>
				    <select className="form-control" id="verifactu_exencion_code" name="verifactu_exencion_code"
				      onChange={this.handleChange} value={this.state.tax && this.state.tax.verifactu_exencion_code ? this.state.tax.verifactu_exencion_code : ''}>
				      <option value="">No aplica (operación sujeta)</option>
				      <option value="SELECCIONAR">Seleccionar en cada factura</option>
				      <option value="E1">E1 — Art. 20 LIVA (enseñanza, salud, financieras...)</option>
				      <option value="E2">E2 — Art. 21 LIVA (exportaciones)</option>
				      <option value="E3">E3 — Art. 22 LIVA (asimiladas a exportaciones)</option>
				      <option value="E4">E4 — Art. 23-24 LIVA (regímenes diplomáticos)</option>
				      <option value="E5">E5 — Art. 25 LIVA (Canarias, Ceuta, Melilla)</option>
				      <option value="E6">E6 — Art. 26 LIVA (otras exenciones)</option>
				      <option value="E7">E7 / N1 — No sujeta Art. 7, 14 LIVA (→ CalificacionOperacion N1)</option>
				      <option value="E8">E8 / N2 — No sujeta por reglas de localización (→ CalificacionOperacion N2)</option>
				    </select>
				    <small className="form-text text-muted">Solo relevante para impuestos al 0%. Define cómo se informa la exención a la AEAT en Verifactu.</small>
				  </div>

				  <div className="d-flex justify-content-between align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={this.saveButton} disabled={this.state.isSaving}>{this.state.isSaving ? 'Guardando...' : 'Guardar'}</button>
					  <button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>
				</form>

			:<span>El impuesto no existe</span>}

			</div>
                </div>

		<Modal />
            </div>
        );
    }

    cursorPointer = {
	cursor: 'pointer',
	width: '100%',
	background: '#CCC',
	padding:'3px',
	fontWeight: 'bold',
	textAlign: 'center'
    }
}

const mapStateToProps = state => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditTax)
